/*
 * Lea Melcher – product options
 *
 * Lea-specific product behaviour.
 * Kept separate from Dawn JavaScript to simplify future theme updates.
 */


/* ---------------------------------------------------------
 * Signature
 * --------------------------------------------------------- */

class LeaSignature {
  constructor(root) {
    this.root = root;

    this.radios = root.querySelectorAll(
      'input[name="properties[Signatur]"]'
    );

    this.individual = root.querySelector(
      '.lea-signature-individual'
    );

    this.container = root.querySelector(
      '.lea-signature-text'
    );

    this.text = root.querySelector(
      '.lea-signature-input'
    );

    if (
      !this.radios.length ||
      !this.individual ||
      !this.container ||
      !this.text
    ) {
      return;
    }

    this.form = document.getElementById(
      this.individual.getAttribute('form')
    );

    this.radios.forEach((radio) => {
      radio.addEventListener('change', () => this.update());
    });

    this.text.addEventListener('input', () => this.update());

    /*
     * Dawn handles Add to Cart with JavaScript.
     * Validate the individual signature explicitly before
     * Dawn processes the product form.
     */
    if (this.form) {
      this.form.addEventListener(
        'submit',
        (event) => {
          if (
            this.individual.checked &&
            !this.text.value.trim()
          ) {
            event.preventDefault();
            event.stopImmediatePropagation();

            this.text.setCustomValidity(
              'Bitte gib den gewünschten Signaturtext ein.'
            );

            this.text.reportValidity();
            this.text.focus();
          }
        },
        true
      );
    }

    this.update();
  }

  update() {
    const isIndividual = this.individual.checked;

    this.text.setCustomValidity('');

    this.container.hidden = !isIndividual;
    this.text.required = isIndividual;

    if (isIndividual) {
      const text = this.text.value.trim();

      this.individual.value = text
        ? `mit Signatur: ${text}`
        : 'mit Signatur';
    }
  }
}


/* ---------------------------------------------------------
 * Preorder
 * --------------------------------------------------------- */

class LeaPreorder {
  constructor(dialog) {
    this.dialog = dialog;

    this.formId = dialog.dataset.productFormId;
    this.form = document.getElementById(this.formId);

    this.addButton = this.form?.querySelector(
      'button[name="add"]'
    );

    this.cancelButton = dialog.querySelector(
      '.lea-preorder-dialog__cancel'
    );

    this.confirmButton = dialog.querySelector(
      '.lea-preorder-dialog__confirm'
    );

    if (
      !this.form ||
      !this.addButton ||
      !this.cancelButton ||
      !this.confirmButton
    ) {
      return;
    }

    /*
     * True only while we replay the customer's original
     * Add-to-Cart click after preorder confirmation.
     */
    this.confirmed = false;

    /*
     * Capture the click before Dawn's product-form handler.
     */
    this.addButton.addEventListener(
      'click',
      (event) => this.handleAddClick(event),
      true
    );

    this.cancelButton.addEventListener(
      'click',
      () => this.close()
    );

    this.confirmButton.addEventListener(
      'click',
      () => this.confirm()
    );

    /*
     * Clicking the backdrop closes the dialog.
     */
    this.dialog.addEventListener('click', (event) => {
      if (event.target === this.dialog) {
        this.close();
      }
    });
  }

  handleAddClick(event) {
    /*
     * This is the replayed click after the customer
     * confirmed the preorder. Let Dawn handle it normally.
     */
    if (this.confirmed) {
      this.confirmed = false;
      return;
    }

    /*
     * Stop this click before Dawn adds the product.
     */
    event.preventDefault();
    event.stopImmediatePropagation();

    this.dialog.showModal();
  }

  close() {
    this.dialog.close();
  }

  confirm() {
    this.dialog.close();

    /*
     * Replay the original Add-to-Cart click once.
     * Our capture handler sees confirmed=true and lets
     * Dawn process the click normally.
     */
    this.confirmed = true;
    this.addButton.click();
  }
}

/* ---------------------------------------------------------
 * Initialization
 * --------------------------------------------------------- */

function initLeaProductOptions() {
  document
    .querySelectorAll('[data-lea-signature]')
    .forEach((root) => {
      if (!root.dataset.leaInitialized) {
        root.dataset.leaInitialized = 'true';
        new LeaSignature(root);
      }
    });

  document
    .querySelectorAll('[data-lea-preorder-dialog]')
    .forEach((dialog) => {
      if (!dialog.dataset.leaInitialized) {
        dialog.dataset.leaInitialized = 'true';
        new LeaPreorder(dialog);
      }
    });
}

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    initLeaProductOptions
  );
} else {
  initLeaProductOptions();
}